<template>
    <div>

        <rkm-alert color="danger" v-if="model.condicao && !model.condicao.cadastroIndividualId">
            <span>Paciente não possui cadastro individual.</span>
        </rkm-alert>

        <rkm-form
            ref="Form"
            show-legend
            v-if="loaded"
        >
            <rkm-area
                type="fieldset"
                title="Identificação do paciente"
            >
                <FormCidadao
                    :data="{ form, model }"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Profissional responsável"
                show-legend
            >
                <FormProfissional
                    :data="{ form, model }"
                    :agendamento="agendamento"
                    :isAmbulatorio="isAmbulatorio"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Condição de saúde"
                v-if="model.condicao && model.condicao.cadastroIndividualId"
            >
                <FormCondicao
                    :data="{ form, model }"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Atendimentos individuais"
            >
                <FormAtendimento
                    :data="{ form, model }"
                    :isAmbulatorio="isAmbulatorio"
                />
            </rkm-area>

             <rkm-area
                v-if="model.cidadao && model.cidadao.idadeAnos >= 60"
                title="IVCF - Índice de vulnerabilidade clínico-funcional"
                type="fieldset"
            >
                <FormIvcf :data="{ model }" />
             </rkm-area>

            <rkm-area
                type="fieldset"
                title="Procedimentos"
                class="mt-3"
            >
                <rkm-button
                    @click="handleProcedimemto"
                    color="primary"
                    slot="trailing"
                    small
                    title="Adicionar"
                >
                    <rkm-icon icon="plus" />
                </rkm-button>

                <FormProcedimento
                    :data="{ form, model }"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Complemento"
            >
                <FormComplemento
                    :data="{ form, model }"
                />
            </rkm-area>
        </rkm-form>

        <Modal
            :data="{ form, model }"
            ref="Modal"
        />
    </div>
</template>

<script>

// Mixins
import { repository, stringCase, data, object, formats, error } from "@/mixins";

// Vuex.
import { mapActions } from "vuex";

// Components
import FormCidadao from './components/cidadao/Form.vue'
import FormProfissional from './components/profissional/Form.vue'
import FormAtendimento from './components/atendimento/Form.vue'
import FormCondicao from './components/condicao/Form.vue'
import FormComplemento from './components/complemento/Form.vue'
import FormProcedimento from './components/procedimento/Form.vue'
import Modal from './components/procedimento/Modal'
import FormIvcf from './components/ivcf/Form'

export default {
    components: {
        FormCidadao,
        FormProfissional,
        FormAtendimento,
        FormCondicao,
        FormComplemento,
        FormProcedimento,
        Modal,
        FormIvcf,
    },
    created() {

        this.repositories = {
            atendimentoIndividual: this.getConectaSusRepository('atencaoBasica.atendimentoIndividual')
        }

        this.load()
    },
    data: () => ({
        additionals: null,
        form: {},
        model: {},
        agendamento: null,
        loaded: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            if (this.id) {

                this.repositories.atendimentoIndividual.edit(this.id)
                    .then(response => {
                        this.additionals = Object.assign(response.data.additionals)
                        this.model = Object.assign(response.data.model)
                        this.form = Object.assign(response.data.form)

                        this.loaded = true

                        this.$emit('loaded', {additionals: this.additionals, model: this.model})
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {

                this.repositories.atendimentoIndividual.show(this.pacienteId)
                    .then(response => {

                        this.additionals = Object.assign(response.data.additionals)
                        this.model = Object.assign(response.data.model)
                        this.form = Object.assign(response.data.form)

                        if (this.isAmbulatorio) {

                            this.$nextTick()
                                .then(() => {

                                    if (this.data.model.atendimentoIndividual) {

                                        this.model = this.data.model.atendimentoIndividual
                                    } else {

                                        this.model.cadastro.usuario = this.data.model.cadastro.usuario
                                        this.model.cadastro.unidadeId = this.data.model.cadastro.unidadeId
                                        this.model.cadastro.infraestruturaId = this.data.model.cadastro.infraestruturaId
                                        this.model.cadastro.equipeId = (this.data.model.cadastro.equipeId ?? this.data.form.equipes[0]?.id) ?? null
                                        this.model.cadastro.ocupacaoId = this.data.model.cadastro.ocupacaoId
                                        this.model.cadastro.dataUsuarioResponsavel = this.data.model.cadastro.dataUsuarioResponsavel
                                        this.model.atendimento.cid1 = this.data.model.cid ?? null
                                    }

                                    this.agendamento = this.data
                                })
                        }

                        this.$nextTick().then(() => this.loaded = true)

                        this.$emit('loaded', {additionals: this.additionals, model: this.model})
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                if (!valid) return

                    this.setLoading()

                    this.repositories.atendimentoIndividual.store(this.prepareData())
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())

            })
        },
        saveAmbulatorio() {

            return this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) {

                        this.$emit('focusTabAtendimentoIndividual')
                        return false
                    } else {

                        this.$emit('saveAtendimentoIndividual', this.model)
                        return true
                    }
            })
        },
        prepareData() {

            const pacienteId = this.model.cidadao.pacienteId
            const cadastro = this.clone(this.model.cadastro)

            cadastro.usuarioId = cadastro.usuario.id
            cadastro.dataUsuarioResponsavel = this.getFormatedDate(cadastro.dataUsuarioResponsavel, 'YYYY-MM-DD')

            if (cadastro.usuarioAuxiliar) {
                cadastro.usuarioAuxiliarId = cadastro.usuarioAuxiliar.id
            }

            const atendimento = this.clone(this.model.atendimento)

            if (atendimento.ciap1) {
                atendimento.ciap1_id = atendimento.ciap1.id
            }

            if (atendimento.ciap2) {
                atendimento.ciap2_id = atendimento.ciap2.id
            }

            if (atendimento.cid1) {
                atendimento.cid1_id = atendimento.cid1.id
            }

            if (atendimento.cid2) {
                atendimento.cid2_id = atendimento.cid2.id
            }

            atendimento.dum = atendimento.dum ? this.getFormatedDate(atendimento.dum, 'YYYY-MM-DD') : null

            const complemento = this.clone(this.model.complemento)
            const condicao = this.clone(this.model.condicao)
            const procedimentos = this.model.procedimentos.map(item => {
                return {
                    procedimentoId: item.id,
                }
            })

            atendimento.ivcf ={
                desejaPreencher: this.model.atendimento.ivcf.desejaPreencher,
                estadoSaudeGeral: this.model.atendimento.ivcf.estadoSaudeGeral,
                limitacaoCompras: this.model.atendimento.ivcf.limitacaoCompras,
                limitacaoGestaoFinanceira: this.model.atendimento.ivcf.limitacaoGestaoFinanceira,
                limitacaoTarefasDomesticas: this.model.atendimento.ivcf.limitacaoTarefasDomesticas,
                banhoIndependencia: this.model.atendimento.ivcf.banhoIndependencia,
                relatoEsquecimentoPorTerceiros: this.model.atendimento.ivcf.relatoEsquecimentoPorTerceiros,
                esquecimentoPiorando: this.model.atendimento.ivcf.esquecimentoPiorando,
                esquecimentoImpactaAtividades: this.model.atendimento.ivcf.esquecimentoImpactaAtividades,
                humorTristezaDesanimo: this.model.atendimento.ivcf.humorTristezaDesanimo,
                perdaInteresseAtividades: this.model.atendimento.ivcf.perdaInteresseAtividades,
                limitacaoElevarBracos: this.model.atendimento.ivcf.limitacaoElevarBracos,
                limitacaoMotricidadeFina: this.model.atendimento.ivcf.limitacaoMotricidadeFina,
                perdaPesoNaoIntencional: this.model.atendimento.ivcf.perdaPesoNaoIntencional,
                imcAbaixo_22: this.model.atendimento.ivcf.imcAbaixo22,
                panturrilhaAbaixo_31: this.model.atendimento.ivcf.panturrilhaAbaixo31,
                marchaLenta_4mMaior_5s: this.model.atendimento.ivcf.marchaLenta4mMaior5s,
                dificuldadeCaminharImpactoAtividades: this.model.atendimento.ivcf.dificuldadeCaminharImpactoAtividades,
                quedasRecorrentes: this.model.atendimento.ivcf.quedasRecorrentes,
                incontinencia: this.model.atendimento.ivcf.incontinencia,
                problemaVisaoImpactoAtividades: this.model.atendimento.ivcf.problemaVisaoImpactoAtividades,
                problemaAudicaoImpactoAtividades: this.model.atendimento.ivcf.problemaAudicaoImpactoAtividades,
                doencasCronicasMultiplas: this.model.atendimento.ivcf.doencasCronicasMultiplas,
                polifarmacia_5OuMaisMedicamentos: this.model.atendimento.ivcf.polifarmacia5OuMaisMedicamentos,
                internacaoUltimos_6Meses: this.model.atendimento.ivcf.internacaoUltimos6Meses,
            }

            delete(cadastro.usuario)
            delete(cadastro.usuarioAuxiliar)
            delete(atendimento.ciap1)
            delete(atendimento.ciap2)
            delete(atendimento.cid1)
            delete(atendimento.cid2)

            return this.camelObjectKeysToSnakeRecursive({
                pacienteId, cadastro, atendimento, complemento, condicao, procedimentos
            })
        },
        handleProcedimemto() {

            if (this.model.cadastro.ocupacaoId) {

                this.$refs.Modal.open()
            } else {

                this.showAlert('É necessário informar a ocupação do usuário responsável.', 'Atenção')
            }
        },
        hasValue(atendimento) {

            return Object.keys(atendimento).some(key => {

                if (key === 'turnoId' || key === 'localAtendimentoId' || key === 'tipoAtendimentoId') {
                    return false;
                }

                const value = atendimento[key];
                return value !== null && value !== false && (!Array.isArray(value) || value.length > 0);
            });
        },

    },
    mixins: [repository, stringCase, data, object, formats, error],
    props: {
        id: { type: Number, default: null },
        pacienteId: { type: Number, default: null },
        isAmbulatorio: { type: Boolean, default: false },
        data: { type: Object, required: false },
    },
    watch: {
        'model': {
            handler(atendimento) {

                if (this.hasValue(atendimento.atendimento) || this.hasValue(atendimento.condicao)
                    || this.hasValue(atendimento.procedimentos.filter(procedimento => procedimento.origem == 'atencaoBasica'))) {

                        this.$emit('handleAtendimentoIndividual', true)
                } else if (atendimento.complemento || atendimento.cadastro.equipeId
                    || atendimento.cadastro.usuarioAuxiliar && atendimento.cadastro.usuarioAuxiliar.id) {

                        this.$emit('handleAtendimentoIndividual', true)
                } else {

                    this.$emit('handleAtendimentoIndividual', false)
                }
            },
            deep: true
        }
    }
}
</script>